import config from '../config/config.json'
import superagent from 'superagent'
import * as c from '../constants/actionTypes';

const AFFILIATE_DETAILS_GET = 'AFFILIATE_DETAILS_GET';
const AFFILIATE_DETAILS_SUCCESS = 'AFFILIATE_DETAILS_SUCCESS';
const AFFILIATE_DETAILS_FAILED = 'AFFILIATE_DETAILS_FAILED';

export {
    AFFILIATE_DETAILS_GET,
    AFFILIATE_DETAILS_SUCCESS,
    AFFILIATE_DETAILS_FAILED
  }
  
    export function getAffiliateDetailsRequest() {
        return {
        type: AFFILIATE_DETAILS_GET,
        loading: true
        }
    }
    
    export function getAffiliateDetailsSuccess(body) {
        return {
        type: AFFILIATE_DETAILS_SUCCESS,
        body: body,
        loading: false
        }
    }
    
    export function getAffiliateDetailsFailure(error) {
        return {
        type: AFFILIATE_DETAILS_FAILED,
        error: error,
        loading: false
        }
    }
    
    export function getAffiliateDetails(couponId) {
        return function(dispatch) {
        dispatch(getAffiliateDetailsRequest())
        superagent
        .get(config.BASE + 'api/admin/affiliate/'+couponId)
        .withCredentials()
        .end((err, res) => {
            if (err) {
            dispatch(getAffiliateDetailsFailure(err))
            alert("error: " + JSON.stringify(err));
            } else {
            dispatch(getAffiliateDetailsSuccess(res.body))
            }
        })
        }
    }


// WEBPACK FOOTER //
// ./src/actions/AffiliateDetails.js